import Vue from "vue"
import VueI18n from "vue-i18n"

import en from "../locales/en"
import es from "../locales/es"
import id from "../locales/id"
import th from "../locales/th"

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "en",
  fallbackLocale: "en",
  messages: {
    en,
    id,
    th,
    es
  },
})
